import gql from 'graphql-tag';

import { getSingleProp, unwrapEdges } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_LINKEDIN_VARIATION_RESULT } from './schema';

const QUERY = gql`
  query LinkedinTextVariationsRequest($adAccountLiId: ID) {
    me {
      id

      linkedinData {
        adAccounts(adAccountLiId: $adAccountLiId) {
          edges {
            node {
              adAccountTextVariationsRequest {
                id
                linkedinVariationResults {
                  edges {
                    node {
                      ...LinkedinVariationResult
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${FRAGMENT_LINKEDIN_VARIATION_RESULT}
`;

export default function queryLinkedinTextVariations(adAccountLiId) {
  return apolloClient
    .query({
      query: QUERY,
      variables: { adAccountLiId },
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => getSingleProp(data))
    .then((result) => {
      const adAccount = result?.linkedinData?.adAccounts?.edges[0]?.node;
      return unwrapEdges(
        adAccount?.adAccountTextVariationsRequest?.linkedinVariationResults?.edges
      );
    });
}
